import Vue from "vue";
import Vuex from "vuex";
import * as auth from "@/store/modules/auth.js";
import * as roles from "@/store/modules/roles.js";
import * as permisos from "@/store/modules/permisos.js";
import * as peritos from "@/store/modules/peritos.js";
import * as cedulas from "@/store/modules/cedulas.js";
import * as users from "@/store/modules/users.js";
import * as logs from "@/store/modules/logs.js";
import * as agenda from "@/store/modules/agenda.js";
import * as centros from "@/store/modules/centros.js";
// import * as perfil from "@/store/modules/perfil.js";
import * as documentos from "@/store/modules/documentos.js";
import * as periodos from "@/store/modules/periodos.js";
import * as informes from "@/store/modules/informes.js";
import * as municipios from "@/store/modules/municipios.js";
import * as nacionalidades from "@/store/modules/nacionalidades.js";
import * as edo_civiles from "@/store/modules/edo_civiles.js";
import * as especialidades from "@/store/modules/especialidades.js";
import * as juzgados from "@/store/modules/juzgados.js";
import * as partidos from "@/store/modules/partidos.js";
import * as especializacion from "@/store/modules/especializacion.js";
import * as telefonos from "@/store/modules/telefonos.js";
import * as domicilios from "@/store/modules/domicilios.js";
import * as carreras from "@/store/modules/carreras.js";


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    roles,
    permisos,
    peritos,
    cedulas,
    users,
    logs,
    agenda,
    centros,
    // perfil,
    documentos,
    periodos,
    informes,
    municipios,
    nacionalidades,
    edo_civiles,
    especialidades,
    juzgados,
    partidos,
    especializacion,
    telefonos,
    domicilios,
    carreras
  },
  state: {
    layout: "dashboard-layout",
    loading: false,
    notification: ""
  },
  mutations: {
    SET_NOTIFICATION(state, payload) {
      // payload = { tipo: 'success', message:'el mensaje de success'}
      state.notification = Object.assign({}, payload);
    },
    CLEAR_NOTIFICATION(state, payload) {
      state.notification = { tipo: "", message: "" };
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_LAYOUT(state, newLayout) {
      state.layout = newLayout;
    }
  },
  actions: {},
  getters: {}
});
